let _cached = null;

export async function getIpInfo() {
	if (_cached) return _cached;

	try {
		const res = await fetch('https://ipapi.co/json/');
		if (!res.ok) return null;
		const data = await res.json();
		if (data.ip) {
			_cached = data;
		}
		return _cached;
	} catch {
		return null;
	}
}
